// extracted by mini-css-extract-plugin
module.exports = {"btn":"AiSelectNavButton_btn__WHiLY"};